import React, { useEffect } from "react";
import { Button, Card, Col, Form, Input, Row } from "antd";
import { SearchOutlined } from "@ant-design/icons";



const updateSearchFilters = (dispatch, requestFilters) => {
    const action = {
        type: "set_search_filters",
        payload: requestFilters
    };
    dispatch(action);
};


const rules = {
    name: [
        {
            required: true,
            min: 3,
            message: "Emri duhet të ketë minimalisht 3 karaktere!",
        },
    ],
};



const Search = ({ dispatch, initialFilters, isLoading }) => {
    const [form] = Form.useForm();


    useEffect(() => {
        let general = null;
        if (initialFilters?.name) {
            general = initialFilters?.name;
        }
        if (initialFilters?.surname) {
            general += " " + initialFilters?.surname;
        }

        form.setFieldsValue({
            general: general,
            listNumber: initialFilters?.listNumber
        })
    }, [form, initialFilters]);


    const onSearch = () => {
        const { general, listNumber } = form.getFieldsValue(['general', 'listNumber']);
        const [name = null, surname = null] = general ? general.split(" ") : [];

        const requestFilters = {
            name: name || name !== "" ? name : null,
            surname: surname || surname !== "" ? surname : null,
            listNumber: listNumber !== null && listNumber !== undefined && listNumber !== "" ? parseInt(listNumber) : null,
        };

        updateSearchFilters(dispatch, requestFilters);
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Form
                    form={form}
                >
                    <Card bodyStyle={{ paddingBottom: "0" }}>
                        <Row gutter={24}>
                            <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                <Form.Item name="general" rules={rules.name}>
                                    <Input
                                        allowClear
                                        type="text"
                                        placeholder="Kërko votues me emër & mbiemër..."
                                        prefix={<SearchOutlined />}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={10} lg={10} md={24} sm={24} xs={24}>
                                <Form.Item name="listNumber">
                                    <Input
                                        allowClear
                                        type="number"
                                        placeholder="Kërko votues me numër liste..."
                                        prefix={<SearchOutlined />}
                                        min={1}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={4} lg={4} md={24} sm={24} xs={24} className="text-right">
                                <Form.Item>
                                    <Button
                                        block
                                        type="primary"
                                        onClick={onSearch}
                                        icon={<SearchOutlined />}
                                    >
                                        Kërko
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                </Form>
            </Col>
        </Row>
    );
};


export default Search;